export default __webpack_public_path__ + "static/jh-hoitaja-75a21924794b31fb05103caed1a1a6bb.jpg";